import React, { useEffect } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Project } from "../../../models/project";
import styles from "./TimelineBar.module.css";
import TimelineItem from "./TimelineItem";

interface TimelineBarProps {
    projectList: Project[];
}

interface Item {
    index: string;
    period: number;
    list: Project[];
}

export default function TimelineBar({ ...props }: TimelineBarProps) {
    // 初期化
    const timelineList: Item[] = [
        { index: "year0", period: 1970, list: [] },
        { index: "year1", period: 1980, list: [] },
        { index: "year2", period: 1990, list: [] },
        { index: "year3", period: 2000, list: [] },
        { index: "year4", period: 2010, list: [] },
        { index: "year5", period: 2020, list: [] },
        { index: "year6", period: 2030, list: [] },
    ];
    const offsetTops: { [key: string]: number } = {
        year0: 0,
        year1: 0,
        year2: 0,
        year3: 0,
        year4: 0,
        year5: 0,
        year6: 0,
    };
    // 年代ごとに内容の高さを計算
    useEffect(() => {
        calcTop(offsetTops);
        // 初期表示
        const scrollContainer = document.querySelector("#scrollContainer");
        if (scrollContainer) scrollContainer.scrollTop = offsetTops["year0"] - 25;
        const initial = document.getElementById("list-year0");
        if (initial) initial.style.color = "var(--red)";
    });

    function calcTop(offsetTops: any) {
        for (let j = 0; j < 7; j++) {
            const content = document.querySelector("#year" + j);
            if (content) {
                offsetTops["year" + j] = (content as HTMLElement).offsetTop;
            }
        }
    }

    // 画面サイズ変化を監視
    window.addEventListener("resize", hanldeResize);
    function hanldeResize() {
        calcTop(offsetTops);
    }

    // 年代別でデータ格納
    if (props.projectList) {
        for (let i = 0; i < props.projectList.length; i++) {
            const element = props.projectList[i];
            for (let j = 0; j < timelineList.length; j++) {
                const timeline = timelineList[j];
                if (element.period === timeline.period) {
                    timeline.list.push(element);
                }
            }
        }
    }

    // スクロールイベントを監視
    const handleScroll = (e: any) => {
        const element = e.target;

        // 年代リスト：色を変え
        const chronologyList = document.querySelectorAll("#chronologyList li");
        for (let index = 0; index < chronologyList.length - 1; index++) {
            const ele = chronologyList[index];
            const current = "year" + index;
            const next = "year" + (index + 1);
            if (
                element.scrollTop >= offsetTops[current] - 40 &&
                element.scrollTop < offsetTops[next] - 40
            ) {
                (ele as HTMLElement).style.color = "var(--studio-btn-bg)";
            } else {
                (ele as HTMLElement).style.color = "var(--gray-85)";
            }
        }
        // 年代リスト：最後の年代
        const lastEle = chronologyList[chronologyList.length - 1];
        if (
            element.scrollTop >= offsetTops["year" + (chronologyList.length - 1)] - 40 &&
            offsetTops["year" + (chronologyList.length - 1)] > 0
        ) {
            (lastEle as HTMLElement).style.color = "var(--studio-btn-bg)";
        } else {
            (lastEle as HTMLElement).style.color = "var(--gray-85)";
        }
    };

    // 年代リストをクリック
    const handleClick = (li: any) => {
        const target = li.target;
        const scrollContainer = document.querySelector("#scrollContainer");
        if (scrollContainer && target.getAttribute("data-content"))
            scrollContainer.scrollTop = offsetTops[target.getAttribute("data-content")] - 38;
    };

    return (
        <div className={styles.timelineBar}>
            {/* 年代リスト */}
            <div className={styles.leftSection}>
                <ul id="chronologyList" onClick={(li) => handleClick(li)}>
                    {timelineList.map((item) => (
                        <li
                            key={"list-" + item.index}
                            id={"list-" + item.index}
                            data-content={item.index}
                            className={styles.listItem}
                        >
                            {item.period}
                            <span style={{ fontSize: "16px" }}>年代</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div
                id="scrollContainer"
                className={styles.rightSection}
                onScroll={(e) => handleScroll(e)}
            >
                <VerticalTimeline
                    layout="1-column"
                    className={styles.verticalTimeline}
                    animate={false}
                >
                    {timelineList.map((item) => (
                        <VerticalTimelineElement
                            key={`key-${item.index}`}
                            id={item.index}
                            className="vertical-timeline-element--work"
                            style={{ display: "block", margin: "0" }}
                            contentStyle={{ boxShadow: "none" }}
                            iconStyle={{
                                background: "var(--studio-btn-bg)",
                                color: "#fff",
                                width: "20px",
                                height: "20px",
                                marginLeft: "8px",
                                top: "-15px",
                                zIndex: 10,
                            }}
                            icon={
                                <div
                                    style={{
                                        color: "black",
                                        marginLeft: "30px",
                                        width: "100px",
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {item.period}
                                    <span style={{ fontSize: "16px" }}>年代</span>
                                </div>
                            }
                        >
                            <div key={`key-${item.period}`} style={{ display: "block" }}>
                                {item.list ? (
                                    <TimelineItem
                                        key={item.index + item.period}
                                        projectList={item.list}
                                    />
                                ) : (
                                    <TimelineItem key={item.index + "blank"} />
                                )}
                            </div>
                        </VerticalTimelineElement>
                    ))}
                </VerticalTimeline>
            </div>
        </div>
    );
}
